import * as React from 'react';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { AgendaMeetingListingView } from '../features/activities/common/AgendaMeetingListingView';

export default function WorkgroupMeetingListingPage(): JSX.Element 
{

	return (
		<ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="workgroupmeeting">
            <AgendaMeetingListingView
                headerIcon='navigation_calendar'
                pageHeader='AMO Møder'
                createNewButtonText='Opret nyt AMO møde'
                currentActivitiesHeader='Aktuelle AMO møder'
                pastActivitiesHeader='TIDLIGERE AMO MØDER'
                type='WorkgroupMeeting' />
		</ProtectedPageWrapper>
	);
}
